import MouseFollower from 'mouse-follower';
// import gsap from 'gsap';
import { getOffset } from '../utils/dom.utils';
import { isTouchDevice } from '../utils/base.utils';
// import { Tween } from 'gsap/gsap-core';
import Swiper from 'swiper';

window.initCursor = function initCursor() {
  const isMouseDevice = window.matchMedia('(pointer: fine)').matches;

  if (!isMouseDevice) return;

  MouseFollower.registerGSAP(gsap);

  const bodyBgEl = document.querySelector('.body-bg');

  const cursorTextsArr = document.querySelectorAll('[data-cursor-text]');
  if (cursorTextsArr.length) {
    cursorTextsArr.forEach((el) => {
      el.classList.add('.cursor-text');
    });
  }

  window.cursor = !isTouchDevice()
    ? new MouseFollower({
        speed: 1.1,
        stickDelta: 0,
        iconSvgSrc: 'app/assets/static/icons/play.svg',
        iconSvgClassName: 'play',
        iconSvgNamePrefix: '-',
        stateDetection: {
          '-pointer': 'a:not(.menu-link),button:not(.menu-link)',
          '-hidden': '.btn-link,.embedsocial-hashtag,.drag-item,.chat-modal',
          // '-hidden':
          //   '.btn-link,.btn,.btn-wr,.dir-control-btn,.dir-control,.btn-to-top,.btn-call',
          '-icon-only': '.btn-icon-only',
          '-first-scroll': '.home-first-sec',
          '-full-video': '.full-video-bg',
          '-btn':
            '.btn-wr,.btn-to-top,.btn-call,.menu-link-btn,.dir-control-btn,.dir-control,.cc-nb-okagree,.cc-nb-reject,.cc-nb-changep,.cc-cp-foot-save,.following-chat-btn,.burger',
          '-cursor-text-hidden': '[data-cursor-text-hidden]',
          '-cursor-title-img': '.first-sec__title-image',
        },
      })
    : null;

  if (cursor) {
    let mouseX = 0;
    let mouseY = 0;

    const updateCursor = () => {
      cursor.position = { x: mouseX, y: mouseY };
      requestAnimationFrame(updateCursor);
    };
    updateCursor();

    window.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });
  }

  /*if (document.querySelector('.bold-loader')) {
    const boldLoader = document.querySelector('.bold-loader');
    boldLoader.addEventListener('mousemove', () => {
      cursor.hide();
    });

    boldLoader.addEventListener('mouseleave', () => {
      cursor.show();
    });
  }

  if (document.querySelector('.bold-loader-new')) {
    const boldLoader = document.querySelector('.bold-loader-new');
    boldLoader.addEventListener('mousemove', () => {
      cursor.hide();
    });

    boldLoader.addEventListener('mouseleave', () => {
      cursor.show();
    });
  }*/

  if (cursor) {
    setTimeout(() => {
      const cursorInner = document.querySelector('.mf-cursor-inner');

      if (cursorInner) {
        /*const customCursor = document.createElement('div');
        customCursor.classList.add('custom-cursor');

        for (let i = 0; i < 4; i++) {
          const span = document.createElement('span');
          span.classList.add(`cursor-span-${i + 1}`);
          customCursor.appendChild(span);
        }

        cursorInner.appendChild(customCursor);*/
      }
    }, 100);
  } else {
  }

  if (cursor) {
    const SCROLL_IDLE_DELAY = 4000;
    const MIN_SHOW_TIME = 2000;

    let scrollIdleTimeout;
    let firstScrollActive = false;
    let mouseMoveListenerAdded = false;
    let scrollActivatedTimestamp = 0;
    let isUserScrolling = false;

    let currentMouseX = 0;
    let currentMouseY = 0;

    const allStates = [
      '-pointer',
      '-hidden',
      '-icon-only',
      '-icon',
      '-burger',
      '-btn',
      '-cursor-text-hidden',
    ];

    const cursorEl = document.querySelector('.mf-cursor');

    const hasAnyActiveState = () =>
      allStates.some((stateClass) => cursorEl.classList.contains(stateClass));

    let lastMouseX = null;
    let lastMouseY = null;

    const onMouseMove = (e) => {
      currentMouseX = e.clientX;
      currentMouseY = e.clientY;

      if (lastMouseX === null || lastMouseY === null) {
        lastMouseX = e.clientX;
        lastMouseY = e.clientY;
        return;
      }

      const deltaX = Math.abs(e.clientX - lastMouseX);
      const deltaY = Math.abs(e.clientY - lastMouseY);

      if (deltaX > 20 || deltaY > 20) {
        lastMouseX = e.clientX;
        lastMouseY = e.clientY;

        if (firstScrollActive && (hasAnyActiveState() || isUserScrolling)) {
          deactivateScrollReminder();
          return;
        }

        const timeSinceActivate = Date.now() - scrollActivatedTimestamp;
        if (firstScrollActive && timeSinceActivate < MIN_SHOW_TIME) {
          return;
        }
      }
    };

    const updateMousePosition = (e) => {
      currentMouseX = e.clientX;
      currentMouseY = e.clientY;
    };

    window.addEventListener('mousemove', updateMousePosition);

    const addMouseMoveListener = () => {
      if (!mouseMoveListenerAdded) {
        window.addEventListener('mousemove', onMouseMove);
        mouseMoveListenerAdded = true;
      }
    };

    const removeMouseMoveListener = () => {
      if (mouseMoveListenerAdded) {
        window.removeEventListener('mousemove', onMouseMove);
        mouseMoveListenerAdded = false;
        lastMouseX = null;
        lastMouseY = null;
      }
    };

    const activateScrollReminder = () => {
      if (hasAnyActiveState() || firstScrollActive) return;

      if (document.querySelector('.bold-popup')) return;

      const elUnderCursor = document.elementFromPoint(
        currentMouseX,
        currentMouseY
      );
      if (elUnderCursor?.closest('.full-video-bg')) return;

      cursor.addState('-first-scroll');
      cursor.addState('-text');
      cursor.setText('Scroll');
      firstScrollActive = true;
      scrollActivatedTimestamp = Date.now();

      addMouseMoveListener();
    };

    const deactivateScrollReminder = () => {
      if (!firstScrollActive) return;

      cursor.removeState('-first-scroll');
      cursor.removeState('-text');
      cursor.removeText();
      firstScrollActive = false;

      removeMouseMoveListener();
    };

    const resetScrollIdleTimer = () => {
      clearTimeout(scrollIdleTimeout);
      deactivateScrollReminder();
      isUserScrolling = true;

      scrollIdleTimeout = setTimeout(() => {
        isUserScrolling = false;
        activateScrollReminder();
      }, SCROLL_IDLE_DELAY);
    };

    let scrollEndTimeout;
    const handleScrollEnd = () => {
      clearTimeout(scrollEndTimeout);
      scrollEndTimeout = setTimeout(() => {
        isUserScrolling = false;
      }, 150);
    };

    if (document.querySelector('.bold-loader-new')) {
      window.addEventListener(
        'scroll',
        () => {
          resetScrollIdleTimer();
          handleScrollEnd();
        },
        { passive: true }
      );

      resetScrollIdleTimer();
    }
  }

  const stickyWrapList = document.querySelectorAll('[data-sticky-wrap]');

  if (!isTouchDevice())
    stickyWrapList.forEach((stickyWrap) => {
      const stickyTarget = stickyWrap.querySelector('[data-sticky-target]');

      stickyWrap.addEventListener('mousemove', (e) => {
        const { top: offsetTop, left: offsetLeft } = getOffset(stickyWrap);

        const x = e.pageX - offsetLeft - stickyWrap.clientWidth / 2;
        const y = e.pageY - offsetTop - stickyWrap.clientHeight / 2;

        const xPosition =
          ((x - stickyWrap.clientWidth / 2) / stickyWrap.clientWidth) * 10;
        const yPosition =
          ((y - stickyWrap.clientHeight / 2) / stickyWrap.clientHeight) * 10;

        gsap.to(stickyWrap, {
          scale: 2,
          ease: 'power2.out',
        });
        gsap.to(stickyTarget, {
          x: xPosition,
          y: yPosition,
          scale: 0.5,
          ease: 'power2.out',
        });

        cursor?.el.style.setProperty('--x-offset', `${xPosition}px`);
        cursor?.el.style.setProperty('--y-offset', `${yPosition}px`);
      });

      stickyWrap.addEventListener('mouseleave', () => {
        gsap.to(stickyWrap, {
          scale: 1,
          ease: 'power2.out',
        });

        gsap.to(stickyTarget, {
          x: 0,
          y: 0,
          scale: 1,
          ease: 'power2.out',
        });

        cursor?.el.style.setProperty('--x-offset', `0px`);
        cursor?.el.style.setProperty('--y-offset', `0px`);
      });
    });

  const iconBtnList = document.querySelectorAll('.btn-icon');

  iconBtnList.forEach((btn) => {
    btn.addEventListener('mouseenter', () => {
      const target = btn.querySelector('.btn-icon__icon-wrap');
      cursor?.setStick(target);
    });

    btn.addEventListener('mouseleave', () => {
      cursor?.removeStick();
    });
  });

  const videoSecEl = document.querySelector('.video-full-sec');

  if (videoSecEl) {
    videoSecEl.addEventListener('mouseenter', () => {
      const cursorEl = document.querySelector('.mf-cursor');
      cursorEl.classList.add('is-video');
      cursor.setIcon('play');
    });

    videoSecEl.addEventListener('mouseleave', () => {
      const cursorEl = document.querySelector('.mf-cursor');
      cursorEl.classList.remove('is-video');
      cursor.removeIcon();
    });
  }

  const iconOnlyBtnList = document.querySelectorAll('.btn');

  iconOnlyBtnList.forEach((btn) => {
    /*btn.addEventListener('mouseenter', () => {
      /!*cursor.setStick(btn);*!/

      if (bodyBgEl.classList.contains('is-dark-bg')) {
      }

      if (bodyBgEl.classList.contains('is-dark-bg')) {
      }
    });

    btn.addEventListener('mouseleave', () => {
      cursor.removeStick();
    });*/
  });

  cursorTextsArr.forEach((element, idx) => {
    const value = element.dataset.cursorText;
    let text = value !== '' ? value : 'Test';

    if (element.classList.contains('home-first-sec')) {
      element.addEventListener('mouseover', () => {
        cursor.setText(`${text}`);
      });

      const mouseEnterEvent = new Event('mouseenter');
      if (element.matches(':hover')) {
        element.dispatchEvent(mouseEnterEvent);
      }
    }

    element.addEventListener('mouseenter', () => {
      cursor.setText(`${text}`);
    });

    element.addEventListener('mouseleave', () => {
      cursor.removeText();
    });
  });

  /*const linkList = document.querySelectorAll('.menu-link');

  linkList.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      cursor.addState('-hidden');
    });

    link.addEventListener('mouseleave', () => {
      cursor.removeState('-hidden');
    });
  });*/

  // function moveElement(e, target) {
  //   Tween.to(target, 0.3, {
  //     css: {
  //       left: e.x - target.offsetWidth / 2,
  //       top: e.y - target.offsetHeight / 2,
  //     },
  //   });
  // }

  /*
  const serviceList = document.querySelector('.services-list');

  if (serviceList) {
    const serviceItems = serviceList.querySelectorAll('.services-list__item');

    const slider = serviceList.querySelector('.services-list__slider');

    if (slider) {
      const swiper = new Swiper(slider, {
        direction: 'vertical',
        speed: 500,
      });

      serviceList.addEventListener('mousemove', (e) => {
        moveElement(e, slider);
      });
      serviceList.addEventListener('mouseenter', () => {
        slider.classList.add('is-show');
      });
      serviceList.addEventListener('mouseleave', () => {
        slider.classList.remove('is-show');
      });

      serviceItems.forEach((item, idx) => {
        item.addEventListener('mouseenter', () => {
          swiper.slideTo(idx);
        });
      });
    }
  }
  */

  const bodyBg = document.querySelector('.body-bg');

  if (bodyBg && cursor) {
    const updateCursorBgClass = () => {
      const cursor = document.querySelector('.mf-cursor');
      cursor.classList.remove('is-cursor-bg-light', 'is-cursor-bg-dark');

      if (
        bodyBg.classList.contains('is-bg-dark') ||
        bodyBg.classList.contains('is-worked-first-fixed-bg') ||
        bodyBg.classList.contains('is-worked-fixed-bg')
      ) {
        cursor.classList.add('is-cursor-bg-dark');
      } else if (bodyBg.classList.contains('is-bg-light')) {
        cursor.classList.add('is-cursor-bg-light');
      }
    };

    updateCursorBgClass();

    const observer = new MutationObserver(updateCursorBgClass);

    observer.observe(bodyBg, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  /*const lightSections = document.querySelectorAll('[data-cursor-bg-light]');
  const darkSections = document.querySelectorAll('[data-cursor-bg-dark]');

  if (lightSections.length) {
    lightSections.forEach((lightSection) => {
      lightSection.addEventListener('mouseenter', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.add('is-cursor-bg-light');
        }
      });

      lightSection.addEventListener('mouseleave', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.remove('is-cursor-bg-light');
        }
      });
    });
  }

  if (darkSections.length) {
    darkSections.forEach((darkSection) => {
      darkSection.addEventListener('mouseenter', () => {
        if (!darkSection.classList.contains('is-hidden-gradient')) {
          const cursor = document.querySelector('.mf-cursor');

          if (cursor) {
            cursor.classList.add('is-cursor-bg-dark');
          }
        }
      });

      darkSection.addEventListener('mouseleave', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.remove('is-cursor-bg-dark');
        }
      });
    });
  }*/
};

if (!document.querySelector('.bold-loader-new')) {
  initCursor();
}

window.refreshCursorElements = function refreshCursorElements() {
  if (!window.cursor) return;

  const cursorTextsArr = document.querySelectorAll('[data-cursor-text]');
  cursorTextsArr.forEach((element) => {
    if (element.dataset.cursorBound) return;

    const value = element.dataset.cursorText;
    const text = value !== '' ? value : 'Test';

    element.addEventListener('mouseenter', () => {
      window.cursor.setText(`${text}`);
    });

    element.addEventListener('mouseleave', () => {
      window.cursor.removeText();
    });

    element.dataset.cursorBound = 'true';
  });

  const iconBtnList = document.querySelectorAll('.btn-icon');
  iconBtnList.forEach((btn) => {
    if (btn.dataset.cursorBound) return;

    const target = btn.querySelector('.btn-icon__icon-wrap');

    btn.addEventListener('mouseenter', () => {
      window.cursor?.setStick(target);
    });

    btn.addEventListener('mouseleave', () => {
      window.cursor?.removeStick();
    });

    btn.dataset.cursorBound = 'true';
  });
};

window.restartCursor = function restartCursor(forceDestroy = false) {
  if (window.cursor && typeof window.cursor.destroy === 'function') {
    window.cursor.destroy();
    window.cursor = null;
  }

  const oldCursorEl = document.querySelector('.mf-cursor');
  if (oldCursorEl && oldCursorEl.parentNode) {
    oldCursorEl.parentNode.removeChild(oldCursorEl);
  }

  initCursor();
};

window.scrollTitleCursor = function scrollTitleCursor() {
  const titlesArr = document.querySelectorAll('.cursor-scroll-title');
  const bodyEl = document.body;

  if (!titlesArr.length) return;

  titlesArr.forEach((element) => {
    element.addEventListener('mouseenter', () => {
      bodyEl.classList.add('is-cursor-scroll-title');
    });

    element.addEventListener('mousemove', () => {
      bodyEl.classList.add('is-cursor-scroll-title');
    });

    element.addEventListener('mouseleave', () => {
      bodyEl.classList.remove('is-cursor-scroll-title');
    });
  });

  const titlesImagesArr = document.querySelectorAll(
    '.first-sec__title-image-wr'
  );
  titlesImagesArr.forEach((element) => {
    element.addEventListener('mouseenter', () => {
      bodyEl.classList.add('is-cursor-scroll-title-image');
    });

    element.addEventListener('mouseleave', () => {
      bodyEl.classList.remove('is-cursor-scroll-title-image');
    });
  });
};

if (!document.querySelector('.bold-loader-new')) {
  scrollTitleCursor();
}
